import {
	WIGGLE_SWATCHES,
	PRODUCT_DETAIL_CLEAR,
	PRODUCT_DETAIL_SUCCESS,
	PRODUCT_DETAIL_ERROR
} from 'actions/productDetailsActions';
import { PAGE_DATA_ACTIONS, MODAL_PAGE_DATA_ACTIONS } from 'actions/pageActionsV4';

export default function (state = {}, action = null) {
	switch (action.type) {
		case WIGGLE_SWATCHES:
			return Object.assign({}, action.data, {
				timestamp: new Date().getTime()
			});
		case PRODUCT_DETAIL_CLEAR:
		case PRODUCT_DETAIL_ERROR:
		case PRODUCT_DETAIL_SUCCESS:
		case PAGE_DATA_ACTIONS.REQUEST:
		case PAGE_DATA_ACTIONS.SUCCESS:
		case PAGE_DATA_ACTIONS.ERROR:
		case PAGE_DATA_ACTIONS.CLEAR:
		case MODAL_PAGE_DATA_ACTIONS.REQUEST:
		case MODAL_PAGE_DATA_ACTIONS.SUCCESS:
		case MODAL_PAGE_DATA_ACTIONS.ERROR:
		case MODAL_PAGE_DATA_ACTIONS.CLEAR:
			return {};
		default:
			return state;
	}
}
